import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import CtaSplit from './components/CtaSplit';
import FeatureCards from './components/FeatureCards';
import ComparisonTable from './components/ComparisonTable';
import ProductGrid from './components/ProductGrid';
import Testimonials from './components/Testimonials';
import GuideSection from './components/GuideSection';
import SafetySection from './components/SafetySection';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL;

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <CtaSplit />
        <FeatureCards />
        <ComparisonTable />
        <ProductGrid />
        <Testimonials />
        <GuideSection />
        <SafetySection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'SuperBuy Spread',
            url: siteUrl,
            description: 'Independent SuperBuy Spreadsheet resource platform helping global shoppers discover products faster with organized spreadsheets, product collections, and buying guides.',
            sameAs: [
              'https://kaspreadsheet.com',
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'SuperBuy Spread',
            url: siteUrl,
            potentialAction: {
              '@type': 'SearchAction',
              target: {
                '@type': 'EntryPoint',
                urlTemplate: `${siteUrl}/?s={search_term_string}`,
              },
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'SuperBuy Spreadsheet — Discover The Best Products, Links & Shopping Guides',
            description: 'Independent SuperBuy Spreadsheet resource platform helping global shoppers discover products faster. Find organized spreadsheets, product collections, buying guides and research tools for smarter purchasing decisions.',
            url: siteUrl,
            isPartOf: {
              '@type': 'WebSite',
              name: 'SuperBuy Spread',
              url: siteUrl,
            },
            about: {
              '@type': 'Thing',
              name: 'SuperBuy Spreadsheet',
              description: 'A structured product research resource that helps shoppers organize product links, categories, comparisons and buying information.',
            },
          }),
        }}
      />
    </div>
  );
}